export function MaterialThemingConfig($mdThemingProvider) {
  "ngInject";

  const orangeMap = $mdThemingProvider.extendPalette('orange', {
    '50': '#FFB480',
    '100': '#FFA566',
    '200': '#FF964D',
    '300': '#FF8733',
    '400': '#FF781A',
    '500': '#FF6900',
    '600': '#E65E00',
    '700': '#CC5400',
    '800': '#B34900',
    '900': '#993F00',
    'A100': '#FFA566',
    'A200': '#FF6900',
    'A400': '#FF781A',
    'A700': '#CC5400',
    'contrastDefaultColor': 'light'
  });

  $mdThemingProvider.definePalette('brightOrange', orangeMap);

  // Use that theme for the primary intentions
  $mdThemingProvider.theme('default')
    .primaryPalette('brightOrange')
    .accentPalette('brightOrange');
}
